import React from "react";
import { navigate } from "../../services";
import styled from "styled-components";
import { Button, BTN_MEDIUM } from "../../lib";

export const Container = styled.div`
    user-select: none;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
`;

export default function CreatePageLink({ doc_id }: { doc_id: number }) {
    return (
        <Container>
            <Button
                size={BTN_MEDIUM}
                messageId="pageForm.new"
                onClick={() => navigate.to(`/app/pages/${doc_id}/create`)}
            />
        </Container>
    );
}
